import { useEffect, useRef } from 'react';

// Campos em que as setas já têm função própria (trocar opção, data ou número).
const SETAS_DO_CAMPO = new Set(['date', 'datetime-local', 'month', 'number', 'time', 'week']);
const campoUsaSetas = alvo => {
  const tag = alvo?.tagName;
  return tag === 'SELECT' || tag === 'TEXTAREA' || (tag === 'INPUT' && SETAS_DO_CAMPO.has(alvo.type));
};

/**
 * Mantém a linha marcada visível ao navegar com o teclado.
 * Uso: <tr ref={marcada ? refLinha : null}>
 */
export function useRolarLinha(indice) {
  const refLinha = useRef(null);
  useEffect(() => {
    if (indice != null && indice >= 0) refLinha.current?.scrollIntoView?.({ block: 'nearest' });
  }, [indice]);
  return refLinha;
}

/**
 * Teclado das janelas de busca: seta para baixo/cima percorre a lista e Enter
 * escolhe a linha marcada, com o foco no campo de busca ou em qualquer lugar da
 * janela. Escuta na fase de captura para a tela de trás não reagir à mesma tecla.
 *
 * indice: posição da linha marcada na lista (-1 ou null se nenhuma).
 * aoMudar(item, i): marca a linha. aoEnter(item, i): escolhe a linha.
 * ativo: false enquanto a janela usa o teclado para outra coisa (ex.: edição na linha).
 */
export default function useNavegacaoLista({ lista, indice, aoMudar, aoEnter, ativo = true }) {
  const atual = useRef();
  atual.current = { lista, indice, aoMudar, aoEnter };

  useEffect(() => {
    if (!ativo) return undefined;
    const aoTeclar = e => {
      const { lista: itens, indice: i, aoMudar: mudar, aoEnter: enter } = atual.current;
      if (!itens?.length) return;
      const temMarcada = i != null && i >= 0 && i < itens.length;

      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (campoUsaSetas(e.target)) return;
        e.preventDefault();
        e.stopPropagation();
        const proximo = !temMarcada ? 0
          : e.key === 'ArrowDown' ? Math.min(i + 1, itens.length - 1) : Math.max(i - 1, 0);
        mudar(itens[proximo], proximo);
        return;
      }
      if (e.key === 'Enter' && temMarcada && enter) {
        // Botão com foco continua respondendo ao próprio Enter (ex.: Cancelar).
        if (e.target?.tagName === 'BUTTON' || e.target?.tagName === 'TEXTAREA') return;
        e.preventDefault();
        e.stopPropagation();
        enter(itens[i], i);
      }
    };
    window.addEventListener('keydown', aoTeclar, true);
    return () => window.removeEventListener('keydown', aoTeclar, true);
  }, [ativo]);

  return useRolarLinha(indice);
}
